import React, { createContext, useState } from 'react';
import PropTypes from 'prop-types';

const defaultState = {
  state: false,
  closeAllMenusOnEsc: () => {},
  resetState: () => {},
};

const Context = createContext(defaultState);

const Provider = ({ children }) => {
  const [state, setState] = useState(false);

  const resetState = () => setState(false);

  const closeAllMenusOnEsc = e => {
    const event = e || window.event;
    if (event.key === 'Escape' || event.keyCode === 27) {
      resetState();
    }
  };

  return (
    <Context.Provider
      value={{
        state,
        setState,
        closeAllMenusOnEsc,
        resetState,
      }}
    >
      {children}
    </Context.Provider>
  );
};

Provider.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
};

export { Context, Provider };
